import { Component } from "react";
import { Container } from "react-bootstrap";
import i18n from "../i18n/i18n";
import { getCurrentLanguage } from "../App";
import { Trans } from "react-i18next";
import LanguageSelector from "../LanguageSelector";


export class Header extends Component {   
    constructor(props){
        super(props);
        i18n.changeLanguage(getCurrentLanguage());
    }

    logoutHandler = () => {
        localStorage.removeItem("user");
        window.location.href = "/signin";
    }

    render() {
        
        return (
            <header className="header">
                <Container style={{padding: 0}}>
                    <div style={{display: 'flex', justifyContent:'space-between', alignItems:'center'}}>
                        <div className="bn-logo">
                            <a href="https://bernard.vn">
                                <img className="logo" src="/images/logo-bernard-1.png" alt="" />
                                <img className="logo logo-ningen" src="/images/ningen.png" alt="" />
                            </a>
                        </div>
                        <div className="header-info">
                            <div className="title">
                                <div className="title-b"><Trans i18nKey='bernard'></Trans></div>
                                <div className="title-r"><Trans i18nKey='bernard_ningendock'></Trans></div>
                            </div>                              
                        </div>
                        <div className="lang" style={{display: 'flex'}}>
                            <LanguageSelector />
                            <button className="language-button " onClick={this.logoutHandler}>
                                <span role="img" aria-label="ENG" className="flag">
                                    <img src="/images/logout.svg" alt="Đăng xuất" className="flag-icon" />
                                </span>
                            </button>
                        </div>   
                    </div>
                </Container>
            </header>
        );
    }
}   